/**
 * @description 保單狀態文字 (enum)
 */
export enum PolicyStatusTextEnum {
  /** 審核中 */
  UnderReview = '審核中',
  /** 已成立 */
  Established = '已成立',
  /** 未繳費 */
  Unpaid = '未繳費',
  /** 契約到期 */
  ContractExpires = '契約到期',
  /** 契約撤銷 */
  ContractRevocation = '契約撤銷',
  /** 已生效 */
  Effective = '已生效'
}
